import axios from 'axios';
import dom from '../lib/dom';
import {toArray} from 'lodash';

export default class DownloadForm {

  constructor(el) {

    this.iphone = (window.navigator.userAgent.indexOf('iPhone') !== -1);
    let safariVersion = window.navigator.userAgent.match(/Version\/(\d+)/);
    this.safariVersion = safariVersion ? parseInt(safariVersion[1], 10) : false;
    this.language = document.documentElement.lang || 'en';

    if (this.iphone && this.safariVersion < 13) {

      el.parentNode.classList.add('hide');
      el.parentNode.previousElementSibling.classList.add('gr-12');
      el.parentNode.previousElementSibling.classList.remove('gr-6');
    } else {

      this.url = '';
      this.form = el;
      this.action = window.routes.requestDownload[0];
      this.method = window.routes.requestDownload[1];
      this.frameCount = 0;
      this.filesSelect = el.elements[0];
      this.qualitySelect = el.elements[1];
      this.submitBtn = el.querySelector('.cta-vodd-movie-download');
      this.formParrent = this.form.parentNode;
      this.sizeNames = [];
      this.getSizes();
      this.registerEvents();
    }
  }

  getSizes() {

    toArray(this.qualitySelect.options).forEach(option => {

      this.sizeNames.push({name: option.innerHTML, value: option.value});
    });

    this.handleNewSizes(JSON.parse(this.filesSelect.querySelector('option[selected="selected"]').dataset.sizes));
  }

  registerEvents() {

    this.filesSelect.addEventListener('touchstart', (e) => {

      e.stopImmediatePropagation();
    }, Modernizr.passiveeventlisteners ? {
      passive: true
    } : false);

    this.submitBtn.addEventListener('click', this.generateUrl.bind(this));
    this.filesSelect.addEventListener('change', this.handleOptionChanged.bind(this));
  }

  handleOptionChanged(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }

    this.handleNewSizes(JSON.parse(e.target.options[e.target.selectedIndex].dataset.sizes));
  }

  handleNewSizes(sizes) {

    toArray(this.qualitySelect.options).forEach((option, index) => {

      option.text = `${this.sizeNames[index].name} (${sizes[option.value]})`;
    });
  }

  generateUrl(e) {

    if (e.preventDefault) {

      e.preventDefault();
    }
    const data = {

      fileId: this.filesSelect.value,
      itemNumber: this.filesSelect.value,
      quality: this.qualitySelect.value
    };

    this.submitBtn.classList.add('is-downloading');

    axios({
      method: this.method,
      url: this.action,
      withCredentials: true,
      data
    })
      .then(res => {
        if (res.data[data.fileId].success) {

          this.url = res.data[data.fileId].url;

          const measuredServerspeeds = JSON.parse(window.localStorage.getItem('swinger.serverspeeds') || '{}');
          const measuredServers = Object.keys(measuredServerspeeds);

          if (
            measuredServers.length &&
            res.data[data.fileId].alternativeUrls &&
            res.data[data.fileId].alternativeUrls.length
          ) {
            const combinedUrls = [res.data[data.fileId].url].concat(res.data[data.fileId].alternativeUrls);

            const cdnUrls = combinedUrls.filter(url => {
              return url.indexOf('c77-') > -1;
            });

            if (cdnUrls.length) {
              this.url = cdnUrls[0];
            } else {
              const matchingServers = measuredServers.filter(server => {
                const hostname = `${server}.dvdl.net`;

                return combinedUrls.join(',').indexOf(hostname) > -1;
              });

              if (matchingServers.length) {
                const fastestMatchingServer = matchingServers.sort((a, b) => {
                  return measuredServerspeeds[b] - measuredServerspeeds[a];
                })[0];

                this.url = combinedUrls
                  .reduce((fastestUrl, url) => {
                    if (url.indexOf(`${fastestMatchingServer}.dvdl.net`) > -1) {
                      fastestUrl = url;
                    }

                    return fastestUrl;
                  }, this.url);

                // eslint-disable-next-line no-console
                console.info('Possible download URLs: ', combinedUrls);
                // eslint-disable-next-line no-console
                console.info(`Fastest download URL: ${this.url}`);
              }
            }
          }

          window._paq = window._paq || [];
          window._paq.push([
            'trackEvent',
            'Download',
            `Quality: ${this.qualitySelect.value}`,
            this.filesSelect,
            this.url
          ]);

          this.handleDownloading();

        } else if (!res.data[data.fileId].success) {

          const availableQualities = res.data[data.fileId].availableQualities ? res.data[data.fileId].availableQualities : false;
          this.handleAlertMessage(res.data[data.fileId].message, availableQualities);
        }
      })
      .catch(error => {

        window.console.log(error);

        throw `DownloadForm.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });

    return false;
  }

  handleDownloading() {

    if (this.iphone) {

      this.submitBtn.setAttribute('href', this.url);
      this.submitBtn.innerHTML = window.appStrings.DownloadForm[this.language].alternativeDownloadButton;
      this.submitBtn.classList.remove('is-downloading');
    } else {

      const hiddenIFrameID = 'hiddenDownloader' + this.frameCount++;
      const iframe = document.createElement('iframe');
      iframe.id = hiddenIFrameID;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      iframe.src = this.url;

      setTimeout(() => {

        this.submitBtn.classList.remove('is-downloading');
      }, 500);
    }
  }

  handleAlertMessage(msg, available) {

    if (!this.alert) {

      this.alert = dom.create('div', {
        class: 'gr-12 alert alert-error'
      }, this.formParrent);

      this.alertMsg = dom.create('div', {
        class: 'inner-wrapper'
      }, this.alert);
    } else {

      this.alert.classList.remove('hide');
    }

    let message = msg;
    if (available) {

      message += window.appStrings.DownloadForm[this.language].availableIn + available;
    }

    this.alertMsg.innerHTML = message;

    setTimeout(() => {
      this.alertMsg.innerHTML = '';
      this.alert.classList.add('hide');
    }, 5000);
  }
}
